// Éclatement panier (LOT 7 §4) — choix de PORTÉE avant modification d'une ligne
// qty > 1 : « Une seule » (split : ligne qty−1 inchangée + ligne qty 1 modifiée)
// ou « Les N » (toute la ligne). Overlay MAISON, purement présentatif, zéro
// écriture (le panier est un état T1 transient).
import { pluriel } from '@/lib/pluriel';

interface Props {
  nom: string;
  qty: number;
  onUneSeule: () => void;
  onToutes: () => void;
  onRetour: () => void;
}

export function PorteeModifOverlay({
  nom,
  qty,
  onUneSeule,
  onToutes,
  onRetour,
}: Props) {
  return (
    <div
      data-testid="portee-modif"
      className="fixed inset-0 z-50 flex items-center justify-center bg-ardoise/40 p-6"
    >
      <div className="flex w-full max-w-2xl flex-col gap-6 rounded-xl border-4 border-ardoise bg-creme p-8">
      <p className="font-cormorant text-4xl italic text-ardoise">
        Modifier {nom} — <span className="font-mono not-italic text-3xl">{qty}</span>{' '}
        {pluriel(qty, 'pizza')} sur la ligne
      </p>
      <div className="flex flex-col gap-4">
        <button
          type="button"
          onClick={onUneSeule}
          className="min-h-[96px] rounded-lg bg-ardoise font-jost text-2xl text-creme"
        >
          Une seule
        </button>
        <button
          type="button"
          onClick={onToutes}
          className="min-h-[96px] rounded-lg border-2 border-ardoise bg-creme font-jost text-2xl text-ardoise"
        >
          Les {qty}
        </button>
        <button
          type="button"
          onClick={onRetour}
          className="min-h-[64px] self-center p-4 font-jost text-lg text-muted-foreground underline"
        >
          Retour
        </button>
      </div>
      </div>
    </div>
  );
}
